import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const vtexIntegrationService = {
    connectIntegration,
    disconnectIntegration,
    getAccounts,
    editProfile,
};

function connectIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/integrations/vtex/authenticate`, requestOptions).then(handleResponse);
}

function disconnectIntegration() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/vtex/revoke-access`, requestOptions).then(handleResponse);
}

function getAccounts() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/vtex/accounts`, requestOptions).then(handleResponse);
}

function editProfile(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/vtex:connect`, requestOptions).then(
        handleResponse,
    );
}
